import { subscribe, TConnectionItem } from '@chocolate-soup-inc/cs-api-consumer-utils';
import { useEffect, useMemo } from 'react';
import { client } from '../../config/api';
import { onSubscriptionData } from '../../config/cache';
import {
  GetCompanyDocument,
  OnAnyCompanyChangedDocument,
  TCompanyFieldsFragment,
  TGetCompanyQuery,
  TGetCompanyQueryVariables,
  TListAllCompaniesFieldsFragment,
  TListAllCompaniesOptionsFieldsFragment,
  TListAllCompaniesOptionsQuery,
  TListAllCompaniesOptionsQueryVariables,
  TListAllCompaniesQuery,
  TListAllCompaniesQueryVariables,
  TListOneCompanyFieldsFragment,
  TListOneCompanyQuery,
  TListOneCompanyQueryVariables,
  TOnAnyCompanyChangedSubscription,
  TOnAnyCompanyChangedSubscriptionVariables,
  useListAllCompaniesLazyQuery,
  useListAllCompaniesOptionsLazyQuery,
  useListOneCompanyLazyQuery
} from '../../generated/graphql';
import { useMap } from '../shared/useMap';
import { useQueryAll } from '../shared/useQueryAll';

//TODO: change onsubcription data to return the company data directly instead of having to do an additional query, excessive hydration
const queryCompanyOnSubscriptionData = async (data?: TOnAnyCompanyChangedSubscription, vars?: TOnAnyCompanyChangedSubscriptionVariables) => {
  const { id, _deleted } = data?.onAnyCompanyChanged || {};

  if (_deleted) return onSubscriptionData(data as Record<string, any>, vars);
  if (!id) return;

  const response = await client.query<TGetCompanyQuery, TGetCompanyQueryVariables>({
    query: GetCompanyDocument,
    variables: {
      id
    }
  });

  const companyData = response.data.getCompany;

  if (companyData) {
    const subscriptionData = {
      onAnyCompanyChanged: companyData as TConnectionItem
    };

    // CHANGED DATA FOR QUERIES THAT DEPEND ON NO VARIABLE (SINCE VARS SHOULD BE AN EMPTY OBJECT IN THIS SITUATION)
    onSubscriptionData(subscriptionData, vars);

    // CHANGED DATA FOR ADDRESS TOO!
    onSubscriptionData(
      {
        onAnyAddressChanged: companyData.address as TConnectionItem
      },
      vars
    );
  }
};

let anyCompanyChangedSubscribed = false;

//TODO: change onsubcription data to return the company data directly instead of having to do an additional query, excessive hydration
export const useSubscribeToCompanyChanged = () => {
  useEffect(() => {
    if (!anyCompanyChangedSubscribed)
      subscribe({
        client,
        query: OnAnyCompanyChangedDocument,
        onSubscriptionData: (data, vars) => {
          return queryCompanyOnSubscriptionData(data as TOnAnyCompanyChangedSubscription, vars as TOnAnyCompanyChangedSubscriptionVariables);
        }
      });

    anyCompanyChangedSubscribed = true;
  }, []);
};

// === NEW ===

export type TCompanyType = TCompanyFieldsFragment;

export const useQueryListAllCompaniesOLD = () => {
  useSubscribeToCompanyChanged();

  const { data, error, loading } = useQueryAll<TListAllCompaniesQuery, TListAllCompaniesQueryVariables>({
    useQuery: useListAllCompaniesLazyQuery,
    variables: { isScan: true }
  });

  //console.log('useQueryListAllCompanies', data, error, loading, fetchMore, nextToken);

  const companies = useMemo(() => data?.listAllCompanies.items || [], [data]);

  return {
    data: companies as TListAllCompaniesFieldsFragment[],
    error,
    loading
  };
};
export const useQueryListAllCompaniesNEW = () => {
  useSubscribeToCompanyChanged();

  const { data, error, loading, fetchMore, nextToken } = useQueryAll<TListAllCompaniesQuery, TListAllCompaniesQueryVariables>({
    useQuery: useListAllCompaniesLazyQuery,
    variables: { limit: 100, isScan: true },
    isScroll: true
  });

  //console.log('useQueryListAllCompanies', data, error, loading, fetchMore, nextToken);

  const companies = useMemo(() => data?.listAllCompanies.items || [], [data]);

  return {
    data: companies as TListAllCompaniesFieldsFragment[],
    error,
    loading,
    fetchMore,
    nextToken
  };
};

export const useQueryListAllCompaniesOptions = () => {
  useSubscribeToCompanyChanged();

  const { data, error, loading, fetchMore, nextToken } = useQueryAll<TListAllCompaniesOptionsQuery, TListAllCompaniesOptionsQueryVariables>({
    useQuery: useListAllCompaniesOptionsLazyQuery,
    variables: { limit: 100, isScan: true }
  });

  //console.log('useQueryListAllCompanies', data, error, loading, fetchMore, nextToken);

  const companies = useMemo(() => data?.listAllCompanies.items || [], [data]);

  return {
    data: companies as TListAllCompaniesOptionsFieldsFragment[],
    error,
    loading,
    fetchMore,
    nextToken
  };
};

export const useQueryListOneCompany = (variables: TListOneCompanyQueryVariables) => {
  useSubscribeToCompanyChanged();

  const { data, error, loading } = useQueryAll<TListOneCompanyQuery, TListOneCompanyQueryVariables>({
    useQuery: useListOneCompanyLazyQuery,
    variables: { ...variables, limit: 1 }
  });

  const company = useMemo(() => data?.listOneCompany.items[0] || {}, [data]);
  return {
    data: company as TListOneCompanyFieldsFragment,
    error,
    loading
  };
};

// === DEPRECATED ===
export const useAllCompaniesMapNEW = () => {
  useSubscribeToCompanyChanged();
  const { data, error, loading } = useQueryListAllCompaniesOLD();

  const companiesMap = useMap(data);

  return {
    data: companiesMap,
    error,
    loading: loading || companiesMap == null
  };
};
